<!-- optional if you want some buttons at the top -->
<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-left></vdr-ab-left>
    <vdr-ab-right>
      <button class="button primary" (click)="createInternalTicket()">
        <clr-icon shape="plus"></clr-icon>
        {{ "ticket.create-a-ticket" | translate }}
      </button>
    </vdr-ab-right>
  </vdr-action-bar>
</vdr-page-block>

<!-- The data table -->
<vdr-data-table-2
  id="ticket-list"
  [filters]="filters"
  [items]="items$ | async"
  [itemsPerPage]="itemsPerPage$ | async"
  [totalItems]="totalItems$ | async"
  [currentPage]="currentPage$ | async"
  (pageChange)="setPageNumber($event)"
  (itemsPerPageChange)="setItemsPerPage($event)"
>
  <!-- optional if you want to support bulk actions -->
  <vdr-bulk-action-menu
    locationId="ticket-list"
    [hostComponent]="this"
    [selectionManager]="selectionManager"
  />

  <vdr-dt2-column [hiddenByDefault]="true" id="id" heading="ID">
    <ng-template let-ticket="item">{{ ticket?.id }}</ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column id="title" [heading]="'ticket.subject' | translate">
    <ng-template let-ticket="item">
      {{ ticket?.title }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column id="requester" [heading]="'ticket.requester' | translate">
    <ng-template let-ticket="item">
      {{ ticket.requester?.firstName + " " + ticket.requester?.lastName }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column id="assignee" [heading]="'ticket.assignee' | translate">
    <ng-template let-ticket="item">
      <div *ngIf="ticket.assignee; else noName">
        {{ ticket.assignee.firstName + " " + ticket.assignee.lastName }}
      </div>
      <ng-template #noName>---</ng-template>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column id="status" [heading]="'ticket.status' | translate">
    <ng-template let-ticket="item">
      <vdr-chip [colorType]="getColorStatus(ticket?.status)">
        {{ ticket?.status }}
      </vdr-chip>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column id="priority" [heading]="'ticket.priority' | translate">
    <ng-template let-ticket="item">
      {{ "ticket." + ticket?.priority | translate }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column id="type" [heading]="'ticket.type' | translate">
    <ng-template let-ticket="item">
      {{ "ticket." + ticket?.type | translate }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [hiddenByDefault]="true"
    id="createdAt"
    [heading]="'common.createdAt' | translate"
  >
    <ng-template let-ticket="item">
      {{ ticket?.createdAt | localeDate : "shortDate" }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [hiddenByDefault]="true"
    id="updatedAt"
    [heading]="'common.updatedAt' | translate"
  >
    <ng-template let-ticket="item">
      {{ ticket?.updatedAt | localeDate : "shortDate" }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column id="dueDate" [heading]="'ticket.due-date' | translate">
    <ng-template let-ticket="item">
      {{ ticket?.dueDate | localeDate : "shortDate" }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column id="action" [heading]="'ticket.view' | translate">
    <ng-template let-ticket="item">
      <a class="button-ghost" [routerLink]="['/extensions/tickets', ticket.id]">
        <span> {{ "ticket.view" | translate }} </span>
        <clr-icon shape="arrow right"></clr-icon>
      </a>
    </ng-template>
  </vdr-dt2-column>
</vdr-data-table-2>
